<template>
    <div v-show="visible">
        <el-dialog title="密码修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="30%">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-form-item prop="password" label="新密码">
                        <el-input v-model="form.password" maxlength="50" show-password></el-input>
                    </el-form-item>
                    <el-form-item   prop="confirmPassword" label="确认密码">
                        <el-input v-model="form.confirmPassword" maxlength="50" show-password></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" @click="save()">确定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    password:"",
                    confirmPassword:""
                },
                rules: {
                    password: [
                        { required: true, message: '请输入新密码', trigger: 'blur' }
                    ],
                    confirmPassword: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(userId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=userId;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        // 验证密码是否相同 
                        if(this.form.password != this.form.confirmPassword){
                             this.$commonFn.showTip('密码不相同，请重新输入！',3);
                             return;
                        }

                        let url= this.resetPwdUrl;
                        let data = {
                            id:this.form.id,
                            password:this.$md5(this.form.password)
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/sys/user/UpdatePwd.vue